import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { RouterModule } from '@angular/router'
import { LinkImageCampusComponent } from './link-image-campus.component'
import { CardImageCampusComponent } from './card-image-campus/card-image-campus.component'

@NgModule({
  declarations: [LinkImageCampusComponent, CardImageCampusComponent],
  imports: [CommonModule, SharedModule, RouterModule],
  exports: [LinkImageCampusComponent],
  providers: [],
})
export class LinkImageCampusModule {}
